import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = ["disabled", "aria-label"]
const _hoisted_3 = {
  class: "pagination-navigation__page-number",
  "aria-current": "page"
}

import NavigationButton from '@lmt-rpb-new/atoms/NavigationButton/NavigationButton.vue';
import { computed } from 'vue';
import { useTranslations } from 'src/storybook/src/composables/translations';
import FaIcon from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import { vTouchTarget } from 'src/directives/TouchTarget/touchTarget';


export default /*@__PURE__*/_defineComponent({
  __name: 'PaginationNavigation',
  props: {
    page: { default: 1 },
    totalPages: { default: undefined },
    hasNext: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    hideLabel: { type: Boolean, default: false },
    centered: { type: Boolean, default: false }
  },
  emits: ['prev', 'next', 'to-start'],
  setup(__props: any) {

const { translate } = useTranslations();

const props = __props;



const isStartPage = computed(() => props.page === 1);
const isEndPage = computed(() => props.page === props.totalPages);
const disabledNext = computed(() => !props.hasNext || isEndPage.value || props.loading);
const disabledPrev = computed(() => isStartPage.value || props.loading);



const calculatePageNumber = computed(() => {
	if (!props.totalPages) {
		return translate('pagination.pageNumberWithoutTotal', {
			page: props.page,
		});
	}
	return translate('pagination.pageNumber', {
		page: props.page,
		totalPages: props.totalPages,
	});
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("nav", {
    class: "pagination-navigation",
    "aria-label": _unref(translate)('pagination.ariaLabel')
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['pagination-navigation__container', { 'pagination-navigation__container--centered': _ctx.centered }])
    }, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "pagination-navigation__to-start",
        type: "button",
        disabled: disabledPrev.value,
        "aria-label": _unref(translate)('pagination.toStart'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('to-start')))
      }, [
        _createVNode(FaIcon, { icon: ['fa-kit', 'fa-chevron-to-start'] })
      ], 8 /* PROPS */, _hoisted_2)), [
        [_unref(vTouchTarget)]
      ]),
      _createVNode(NavigationButton, {
        direction: 'prev',
        disabled: disabledPrev.value,
        class: "pagination-navigation__prev",
        "aria-label": _unref(translate)('pagination.toPrevious'),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('prev')))
      }, null, 8 /* PROPS */, ["disabled", "aria-label"]),
      _createElementVNode("span", _hoisted_3, [
        (!_ctx.hideLabel)
          ? _renderSlot(_ctx.$slots, "page-number", {
              key: 0,
              page: _ctx.page,
              totalPages: _ctx.totalPages
            }, () => [
              _createTextVNode(_toDisplayString(calculatePageNumber.value), 1 /* TEXT */)
            ])
          : _createCommentVNode("v-if", true)
      ]),
      _createVNode(NavigationButton, {
        direction: 'next',
        disabled: disabledNext.value,
        class: "pagination-navigation__next",
        "aria-label": _unref(translate)('pagination.toNext'),
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('next')))
      }, null, 8 /* PROPS */, ["disabled", "aria-label"])
    ], 2 /* CLASS */)
  ], 8 /* PROPS */, _hoisted_1))
}
}

})